module.exports = __webpack_public_path__ + "static/media/2.4fa7d4e8.svg";